import type { IUser } from '@hit-game/shared/types';

import { http } from '../lib/http';

export type AuthUser = Pick<IUser, '_id' | 'username' | 'role' | 'status'>;

export const authService = {
  login(username: string, password: string): Promise<{ user: AuthUser }> {
    return http.post('/auths/login', { username, password });
  },

  logout(): Promise<null> {
    return http.post('/auths/logout', {}, { _silent: true });
  },

  /**
   * Phiên hiện tại theo SERVER, không phải theo localStorage.
   *
   * Chưa đăng nhập thì 401 là kết quả BÌNH THƯỜNG của lời gọi này, nên tắt cả
   * toast lẫn xử lý 401 tự động — để interceptor refresh + điều hướng ở đây sẽ
   * thành vòng lặp tải lại trang login.
   */
  me(): Promise<AuthUser> {
    return http.get('/users/me', { _silent: true, _skipAuthHandling: true });
  },
};
